export class IntentType {
  static PRIMARY = 'primary';
  static SECONDARY = 'secondary';
  static TERTIARY = 'tertiary';
  static WARN = 'warn';
  static INVALID = 'invalid';
  static VALID = 'valid';
  static NONE = null;
}
